var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.38564 1.06997C0.623176 0.730631 1.09082 0.648105 1.43016 0.88564L5.43016 3.68564C5.62372 3.82113 5.74212 4.03991 5.74968 4.27606C5.75724 4.51221 5.65308 4.73812 5.46859 4.88572L1.46859 8.08572C1.14514 8.34447 0.67317 8.29203 0.414413 7.96859C0.155656 7.64514 0.208097 7.17317 0.531543 6.91441L3.74942 4.34011L0.569968 2.11449C0.230631 1.87695 0.148105 1.4093 0.38564 1.06997Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38564 1.06997C6.62318 0.730631 7.09082 0.648105 7.43016 0.88564L11.4302 3.68564C11.6237 3.82113 11.7421 4.03991 11.7497 4.27606C11.7572 4.51221 11.6531 4.73812 11.4686 4.88572L7.46859 8.08572C7.14514 8.34447 6.67317 8.29203 6.41441 7.96859C6.15566 7.64514 6.2081 7.17317 6.53154 6.91441L9.74942 4.34011L6.56997 2.11449C6.23063 1.87695 6.1481 1.4093 6.38564 1.06997Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3856 1.06997C12.6232 0.730631 13.0908 0.648105 13.4302 0.88564L17.4302 3.68564C17.6237 3.82113 17.7421 4.03991 17.7497 4.27606C17.7572 4.51221 17.6531 4.73812 17.4686 4.88572L13.4686 8.08572C13.1451 8.34447 12.6732 8.29203 12.4144 7.96859C12.1557 7.64514 12.2081 7.17317 12.5315 6.91441L15.7494 4.34011L12.57 2.11449C12.2306 1.87695 12.1481 1.4093 12.3856 1.06997Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.edafc141fbef221350dc709af9c39ee8.svg";
export { ForwardRef as ReactComponent };